import React, { useContext } from 'react'
import globalStyles from "../../../../../../../assets/styles/global.module.scss";
import chatStyles from "../../../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import contactStyles from "../../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import feedbackStyles from "../../../../../../../assets/styles/componentStyles/feedbackDialog.module.scss"
import { Badge, Divider, Fab, Grid, TextField, Typography } from '@mui/material';
import { CannedResponseMessage, sendCannedResponsePayload, sendTemplatePayload, uploadedMedia } from '../../../../../../../models/axiosModel';
import SendIcon from '@mui/icons-material/Send';
import { useShallow } from 'zustand/react/shallow';
import { useInsertVariableAtCursorPosition } from '../../../../../../../hooks/useInsertVariableAtCursorPosition';
import { UserContext, UserContextPayload } from '../../../../../../../context/userContext';
import { checkInternetConnection } from '../../../../../../../utils/constants';
import { CANNED_RESPONSE_VARIABLES } from '../../../../../constants';
import { extractFileNameFromUrl, replaceCannedResponseVariables, sendCannedResMsg } from '../../../../../utils';
import { renderMediaMsg } from '../../../../../renderUtils';
import { useRuleBasedInboxStore } from '../../../../../../../store/ruleBasedInboxStore';

interface PreviewAndSendPopupProps {
    handleSendMessageManually: (inputValue: string, flagMediaMessage: boolean, flagCannedResponseTemplate: boolean, flagTemplateMessage: boolean, selectedMediaSet: uploadedMedia[], sendTemplatePayload: sendTemplatePayload | null, cannedResponsePayload?: sendCannedResponsePayload) => Promise<void>,
} 

const getContentType = (media: CannedResponseMessage) => {
    return media?.content_type?.name?.toLowerCase() ?? '';
}

const PreviewAndSendPopup: React.FC<PreviewAndSendPopupProps> = (props) => {
    
    const { handleSendMessageManually } = props;

    const { registerTextarea, insertVariable } = useInsertVariableAtCursorPosition();

    const { currentActiveChatbotThread, currentCannedRes, setFlagPreviewAndSendCannedResPopup, onChangeOfCannedResMsg } = useRuleBasedInboxStore(useShallow((state) => ({
        currentActiveChatbotThread: state.currentActiveChatbotThread,
        currentCannedRes: state.currentCannedRes,
        setFlagPreviewAndSendCannedResPopup: state.setFlagPreviewAndSendCannedResPopup,
        onChangeOfCannedResMsg: state.onChangeOfCannedResMsg,
    })))

    const { userDetail } = useContext(UserContext) as UserContextPayload;
    const innerHeight = window.innerHeight - 250;

    const getMediaCaption = (media: CannedResponseMessage) => {
        let caption = "";
        if(currentActiveChatbotThread){
            caption = replaceCannedResponseVariables(media?.message_content, currentActiveChatbotThread?.channel_name, currentActiveChatbotThread?.thread_metadata, userDetail)
        }
        return caption;
    }

    const onClickOfSendCannedMsg = () => {
        if (!checkInternetConnection()) { 
            return;
        }
        sendCannedResMsg(currentCannedRes, handleSendMessageManually, userDetail); 
        setFlagPreviewAndSendCannedResPopup(false)
    }

    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                            <Typography className={contactStyles.popupTitleTypography}> {`Preview of ${currentCannedRes?.template_title ?? ''}`}</Typography>
                        </Grid>

                        <Divider className={contactStyles.popupTitleDivider} />

                        <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`} sx={{ maxHeight: `${innerHeight}px !important` }}>
                            <Grid container className={contactStyles.popupBodyGridContainer} gap={2}>
                                {currentCannedRes?.canned_response_messages?.map((media, index) => {
                                    return (
                                        <>
                                            <Grid item xs={12}>
                                                <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                                    {`Message ${index + 1}`}
                                                </Typography>
                                            </Grid>
                                            {getContentType(media) === "text" ?
                                                <Grid item xs={12}>
                                                    <Grid container className={globalStyles.displayFlexStyle}>
                                                        <Grid item xs={12}>
                                                            <textarea
                                                                rows={3}
                                                                placeholder={`Enter Message Content`}
                                                                className={`${feedbackStyles.longTextFeedbackInputField} ${chatStyles.cannedResponseMessageTextarea}`}
                                                                ref={(el) => registerTextarea(index, el)}
                                                                value={currentCannedRes?.canned_response_messages[index]?.message_content ?? ''}
                                                                onChange={(e) => onChangeOfCannedResMsg(e.target.value, index)}
                                                            />
                                                        </Grid>
                                                        <Grid item>
                                                            <Grid container gap={"15px"}>
                                                                {CANNED_RESPONSE_VARIABLES?.map((variable) => {
                                                                    return (
                                                                        <Grid item>
                                                                            <Typography
                                                                                className={chatStyles.cannedResVariable}
                                                                                onMouseDown={(e) => e.preventDefault()}
                                                                                onClick={() => {
                                                                                    const messageContentAfterVariableInsert = insertVariable(variable?.key ?? '', index, currentCannedRes?.canned_response_messages?.[index]?.message_content ?? '');
                                                                                    onChangeOfCannedResMsg(messageContentAfterVariableInsert, index);
                                                                                }}
                                                                            >
                                                                                {variable?.label}
                                                                            </Typography>
                                                                        </Grid>
                                                                    );
                                                                })}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item xs={12} className={`${globalStyles.displayFlexStyle}`}>
                                                        {renderMediaMsg(getContentType(media), media?.message_url, '', extractFileNameFromUrl(media?.message_url), true)}
                                                    </Grid>
                                                    {getContentType(media) != 'document' && 
                                                        <Grid item xs={12} className={`${globalStyles.displayFlexStyle} ${globalStyles.wordBreakBreakWord}`}>
                                                            <Typography className={chatStyles.mediaFileNameTypography}>{extractFileNameFromUrl(media?.message_url)}</Typography>
                                                        </Grid>
                                                    }
                                                    {getMediaCaption(media)  && 
                                                        <Grid item xs={12}>
                                                            <Grid container gap={0.5} className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn}`}>
                                                                <Grid item xs={12}>
                                                                    <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                                                        Message Content
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextField
                                                                        value={getMediaCaption(media)}
                                                                        disabled={true}
                                                                        className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                                                    />  
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                </>
                                            }
                                            {(index !== currentCannedRes?.canned_response_messages?.length - 1) && 
                                                <Grid item xs={12}>
                                                    <Divider />
                                                </Grid>
                                            }
                                        </>     
                                    )
                                })}
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container className={`${globalStyles.displayFlex} ${globalStyles.contentEnd}`} padding={"20px 20px"} gap={"12px"}>
                                <Grid 
                                    item 
                                    className={globalStyles.clickable} 
                                    onClick={() => onClickOfSendCannedMsg()}
                                > 
                                    <Badge
                                        badgeContent={currentCannedRes?.canned_response_messages?.length}
                                        color="error"
                                        overlap="circular" 
                                        className={chatStyles.sendButtonBadge}
                                    >
                                        <Fab className={chatStyles.sendIconFab} size="medium" aria-label="send">
                                            <SendIcon className={chatStyles.sendMediaIcon} />
                                        </Fab>
                                    </Badge>
                                </Grid>
                            </Grid>
                        </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default PreviewAndSendPopup
